export default __webpack_public_path__ + "static/media/google_sheet.af3e9536.png";